import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row;
  align-self: center;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: left;
  padding: 40px 45px;
`;

export const CloseWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0.5em 0.5em 0;
`;
